"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MasterArea_1 = __importDefault(require("../MasterArea"));
var MasterAreaItem_1 = __importDefault(require("../MasterAreaItem"));
var RelativeLink_1 = __importDefault(require("../RelativeLink"));
var CrudMaster = function (props) {
    var titleExtractor = props.titleExtractor, descriptionExtractor = props.descriptionExtractor, idExtractor = props.idExtractor, valueActiveExtractor = props.valueActiveExtractor, filterPredicate = props.filterPredicate, filterInfinity = props.filterInfinity, items = props.items, infinityItems = props.infinityItems, icon = props.icon, iconDisable = props.iconDisable, colorDisable = props.colorDisable, selectedId = props.selectedId, onYReachEnd = props.onYReachEnd;
    var _a = react_1.useState([]), filteredItems = _a[0], setFilteredItems = _a[1];
    var _b = react_1.useState(''), filterTerm = _b[0], setFilterTerm = _b[1];
    react_1.useEffect(function () {
        var filterItems = function (itemsToFilter, value) {
            var filteredData = value ? itemsToFilter.filter(function (item) { return filterPredicate(item, value); }) : itemsToFilter;
            setFilterTerm(value);
            setFilteredItems(filteredData);
        };
        filterItems(items, filterTerm);
    }, [items, filterTerm, filterPredicate]);
    return (react_1.default.createElement(MasterArea_1.default, { type: "list", dataSource: infinityItems || filteredItems, onYReachEnd: onYReachEnd, onSearch: filterInfinity || setFilterTerm, renderItem: function (item) {
            var id = idExtractor ? idExtractor(item) : item.id;
            var iconItem = iconDisable && valueActiveExtractor && !valueActiveExtractor(item) ? iconDisable : icon;
            var colorItem = iconDisable && valueActiveExtractor && !valueActiveExtractor(item) ? colorDisable : undefined;
            return (react_1.default.createElement(RelativeLink_1.default, { to: "detail/" + id },
                react_1.default.createElement(MasterAreaItem_1.default, { type: "list", icon: iconItem, colorIcon: colorItem, active: !!selectedId && selectedId.toString() === id.toString(), item: item, title: titleExtractor(item), description: descriptionExtractor(item) })));
        } }));
};
exports.default = CrudMaster;
